import {Injectable} from '@angular/core';
import {UUIDService} from '@app/shared/services/util/uuid.service';
import {Observable, Subject} from 'rxjs';
import {Toast} from './Toast';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private uuidService: UUIDService) {}

  private subject = new Subject<Toast>();
  private closeToastIdSubject = new Subject<string>();

  push(toast: Toast): void {
    this.subject.next(toast);
  }

  closeToastById(toastId: string): void {
    this.closeToastIdSubject.next(toastId);
  }

  getToaster(): Observable<Toast> {
    return this.subject.asObservable();
  }

  getToastIdToClose(): Observable<string> {
    return this.closeToastIdSubject.asObservable();
  }

  generateToasterId(): string {
    return this.uuidService.generateUUID();
  }
}
